import { useParams } from 'react-router';

import { useGetMainPageQuery } from '@/api/endpoints/mainPages';
import { FetchDataWrapper } from '@/shared/components';

import { MainEditPageContent } from './MainEditPageContent';

export const MainEditPage = () => {
  const { id } = useParams();

  const {
    data: pageData,
    isLoading: isPageLoading,
    isError: isPageDataFetchError,
  } = useGetMainPageQuery({ id: Number(id) });

  return (
    <FetchDataWrapper
      isLoading={isPageLoading}
      isError={isPageDataFetchError}
    >
      {pageData && <MainEditPageContent pageData={pageData} />}
    </FetchDataWrapper>
  );
};
